import React from 'react';

import {getUserLink} from 'app/general/dashboards/ItemLastActivity';
import {gt} from 'app/utils/i18n';

import type {
  DetailPolicySerializedType,
  ProcedureHashidSerializedType,
  ProcessHashidSerializedType,
} from 'sweet-types';
type Props = {
  document:
    | ProcedureHashidSerializedType
    | DetailPolicySerializedType
    | ProcessHashidSerializedType;
};

export const ManagersList = ({document}: Props) => (
  <div className="mb-1 text-muted">
    <small>
      {gt('Managed by')}&nbsp;
      {document.managers.map((manager, i) => (
        <span key={manager.id}>
          {getUserLink(manager)}
          {document.managers.length - 1 !== i && (
            <span className="persistent separator"> • </span>
          )}
        </span>
      ))}
    </small>
  </div>
);
